import { NgModule, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnimalSelectionAnimalDetailsDialogComponent } from './animal-selection-animal-details-dialog.component';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-light-svg-icons';
import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@ngneat/transloco';
import { TranslocoLocaleModule } from '@ngneat/transloco-locale';
import { DetailsTableModule } from '@tcc-mono/shared/ui/details-table';
import { DialogLayoutModule } from '@tcc-mono/shared/ui/dialog-layout';
import { SharedUtilsModule } from '@tcc-mono/shared/utils';
import { AnimalLookupDialogModule } from '@tcc-mono/vandijk/shared/features/animal-lookup-dialog';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    DialogLayoutModule,
    SharedUtilsModule,
    DetailsTableModule,
    TranslocoModule,
    FontAwesomeModule,
    TranslocoLocaleModule,
    AnimalLookupDialogModule
  ],
  declarations: [AnimalSelectionAnimalDetailsDialogComponent],
  exports: [AnimalSelectionAnimalDetailsDialogComponent]
})
export class AnimalSelectionAnimalDetailsDialogModule {
  private readonly _lib = inject(FaIconLibrary);

  constructor() {
    this._lib.addIcons(faCircleInfo);
  }
}
